export default __webpack_public_path__ + "static/icon-35-4-4e88adde7d34026963fd7bdf9405684c.png";